import React, { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Container, Divider } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import useAgreementSelection from "hooks/useAgreementSelection"
import useApiLoading from "hooks/useApiLoading"
import TopContents from "organisms/common/TopContents"
import Announce from "molecules/Announce"
import BottomContents from "organisms/common/BottomContents"
import CampaignEntryThanks from "molecules/CampaignEntryThanks"
import CampaignBottomTerm from "molecules/CampaignBottomTerm"
import CampaignAnnounce from "molecules/CampaignAnnounce"

const useStyle = makeStyles(theme => ({
  root: {
    padding: "15px",
    paddingLeft: "30px",
    paddingRight: "30px",
    minHeight: "calc(100vh - 144px)",
    [theme.breakpoints.down("xs")]: {
      minHeight: "calc(100vh - 138px)",
    },
  },
}))

const Contents = ({ location }) => {
  const classes = useStyle()
  const history = useHistory()
  const { agreementSelection } = useAgreementSelection()
  const { isCampaign, entry } = agreementSelection.campaign
  const { isApiLoading } = useApiLoading()
  const pathname = (location && location.state && location.state.pathname) || ""
  const fromTop = pathname === "/" || pathname === "/callback"

  useEffect(() => {
    history.replace("/thanks", undefined)

    if (!fromTop) {
      history.push("/")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container maxWidth="md" className={classes.root}>
      {!isApiLoading && (
        <>
          {isCampaign && entry && (
            <CampaignEntryThanks data-testid="CampaignEntryThanks" />
          )}
          <TopContents descriptionId="AgreementSelectionContents.Text2" />
          {isCampaign && entry ? (
            <>
              <CampaignBottomTerm data-testid="CampaignBottomTerm" />
              <CampaignAnnounce data-testid="CampaignAnnounce" />
            </>
          ) : (
            <Announce />
          )}
          <Divider />
          <BottomContents />
        </>
      )}
    </Container>
  )
}

export default Contents
